export default __webpack_public_path__ + "resources/icons/n121-5959.webp";